
export enum CaseStudySearchActionTypes {
    GET_CASE_STUDY_RESULTS = "@@casestudy/GET_CASE_STUDY_RESULTS",
    LOADING = '@@casestudy/LODADING',
    GET_EXPORT_DATA = "@@casestudy/GET_EXPORT_DATA",
    SET_SELECTED_ROWS = '@@casestudy/SET_SELECTED_ROWS'
}